import {
  EditGuesser,
  FieldGuesser,
  InputGuesser,
  ListGuesser,
} from "@api-platform/admin";
import { ReferenceArrayInput, SelectArrayInput } from "react-admin";
import { JsonInput } from "react-admin-json-view";
import TextInputStyle from "../style/TextInputStyle";

const CableCoreSectionList = (props: any) => (
  <ListGuesser {...props}>
    <FieldGuesser source="area" />
    <FieldGuesser source="title" />
  </ListGuesser>
);

const CableCoreSectionEdit = (props: any) => (
  <EditGuesser {...props}>
    <InputGuesser style={TextInputStyle} source={"area"} />
    <InputGuesser style={TextInputStyle} source={"title"} />
    <InputGuesser style={TextInputStyle} source={"sortIndex"} />

    <ReferenceArrayInput
      source="fireHazardClasses"
      reference="cable_fire_hazard_classes"
    >
      <SelectArrayInput optionText="title" />
    </ReferenceArrayInput>

    <JsonInput
      source={"textGenVars"}
      reactJsonOptions={{
        name: null,
        displayDataTypes: false,
        displayObjectSize: false,
        enableClipboard: false,
        onAdd: () => {},
      }}
    />
    <JsonInput
      source={"modelVars"}
      reactJsonOptions={{
        name: null,
        displayDataTypes: false,
        displayObjectSize: false,
        enableClipboard: false,
        defaultValue: "",
        onAdd: () => {},
      }}
    />
  </EditGuesser>
);

export { CableCoreSectionList, CableCoreSectionEdit };
